/** Same asset as `components/WhitePaper/WhitePaper.jsx` — use for download links when the full section is not on the page. */
import whitepaperPdf from "../assets/img/images/whitepaper.pdf";

export default whitepaperPdf;
